﻿import window from 'window';
import document from 'document';

export const scrollTop = (() => {

    let activeAnimation;

    const stop = () => {
        activeAnimation = false;
    };
    
    /**
    * Simulates the animated scrollTop of jQuery. Used when css3:false or scrollBar:true or autoScrolling:false
    */
   const scrollTo = (params) => {
    const element = typeof params.element !== 'undefined' ? params.element : window;
    const to = params.to;
    const duration = typeof params.duration !== 'undefined' ? params.duration : 700;
    const callback = typeof params.callback !== 'undefined' ? params.callback : null;
    const easing = typeof params.easing !== 'undefined' ? params.easing : Math.easeInOutCubic;

    const start = element!==window ? element.scrollTop : (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);
    const change = to - start;
    let currentTime = 0;
    const increment = 16; //same amount of milliseconds as requestAnimationFrame
    activeAnimation = true;

    const animateScroll = () => {

         //in case we want to stop it from other function whenever we want
        if (activeAnimation) {
            currentTime += increment;
            const easingValue = duration ? easing(currentTime, start, change, duration) : to;
            element.scrollTo(0, easingValue);

            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            } else if (callback){
                callback();
            }
        }else if (currentTime < duration && callback){
            callback();
        }
    };

    animateScroll();
   }

   return {
    scrollTo,
    stop
   };

})();